import { useMemo } from 'react';
import { Carousel } from 'antd';
import { useTranslation } from 'react-i18next'; // 假设你使用 react-i18next
import config from 'config';
import './Notification.scss';

const Notification = () => {
  const { i18n } = useTranslation();

  const notifications = useMemo(() => {
    const lang = i18n.language.startsWith('zh') ? 'zh' : 'en';
    return config.NOTIFICATIONS[lang] || config.NOTIFICATIONS.en;
  }, [i18n.language]);

  if (!config.SHOW_NOTIFICATION_BAR) {
    return null;
  }

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="notification-container">
      <Carousel
        dotPosition="left"
        dots={false}
        infinite={true}
        autoplay
        autoplaySpeed={2000}
      >
        {notifications.map((notification: string, index: number) => (
          <div key={index} className="notification-slide">
            {notification}
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Notification;